import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';

import { ApplicationState } from 'store/redux';
import * as AuthenticationStore from 'store/redux/Authentication';
import { LoginState } from 'store/redux/Authentication';
import './Home.css';

export type IHomeProps = typeof AuthenticationStore.actions & {
  authenticationState?: AuthenticationStore.UserState;
};

const Home = ({ authenticationState }: IHomeProps) => {
  const { t } = useTranslation('translation');
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const isLoggedIn = authenticationState
    ? authenticationState.LoginState === LoginState.LOGGED_IN
    : false;
  const customerHasBeenSelected =
    isLoggedIn &&
    !!authenticationState &&
    !!authenticationState.UserInRole &&
    !!authenticationState.UserInRole.selectedCustomer;
  const [showMoviesItem, setShowMoviesItem] = useState(false);

  useEffect(() => {
    if (isLoggedIn && !customerHasBeenSelected) {
      setShowMoviesItem(false);
    } else {
      authenticationState?.UserInRole?.selectedCustomer &&
        setShowMoviesItem(
          authenticationState?.UserInRole?.selectedCustomer?.movieServiceIsAvailable
        );
    }
  }, [isLoggedIn, customerHasBeenSelected, authenticationState?.UserInRole?.selectedCustomer]);

  return (
    <div>
      <div className="container image-container">
        <div className="row limited">
          <Alert key="warning" variant="warning" className="alert-warning" isOpen={false}>
            <Trans i18nKey="home.GATHERING_INFO" ns="translation">
              <p></p>
              <br />
            </Trans>
          </Alert>
          <img className="col-12" src="/assets/images/hero-start.jpg" alt="" />

          <div className=" col-4 offset-md-8 overlay col-md-hide hidden">
            <div className="overlay-content">
              <h3>{t('home.WIZARD_MOVING_FORWARD')}</h3>
              <p>{t('home.WIZARD_INFO')}</p>
              <button className="startIntroTrigger btn-primary">
                <i className="fa fa-play-circle-o" /> {t('home.WIZARD_BUTTON')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-4">
        <div className="row main-content limited">
          <div className="col-12 col-md-8 ingress px-4">
            <Trans i18nKey="home.INFO" ns="translation">
              <p style={{ textAlign: 'left' }}></p>
            </Trans>
          </div>
          <div className="col-12 col-md-4 px-4 ">
            <Trans i18nKey="home.PUSH_ENVIRONMENT_AUTHORITY" ns="translation">
              <a className="pill-primary link" target="_blank" href="https://www.av.se">
                <i className="fa fa-chevron-right"></i> {t('home.PUSH_ENVIRONMENT_AUTHORITY')}
              </a>
              <a className="pill-primary link" target="_blank" href="https://www.av.se/en">
                <i className="fa fa-chevron-right"></i> {t('home.PUSH_ENVIRONMENT_AUTHORITY')}
              </a>
            </Trans>
            {/* {showMoviesItem && (
                            <div>
                                <a className="pill-primary link" onClick={toggle}>
                                    {!isOpen ? <i className="fa fa-chevron-right"></i> : <i className="fa fa-chevron-down"></i>}
                                    <span className="p-1">{t('home.PUSH_MOVIES')}</span>
                                </a>
                                <CustomerMovies isOpen={isOpen} />
                            </div>
                        )} */}
            <Trans i18nKey="home.PUSH_DIGITAL_SERVICES" ns="translation">
              <a
                className="pill-primary link"
                target="_blank"
                href="https://issuu.com/avonova/docs/avonova_tj_nstekatalog"
              >
                <i className="fa fa-chevron-right"></i> {t('home.PUSH_DIGITAL_SERVICES')}
              </a>
              <a
                className="pill-primary link"
                target="_blank"
                href="https://issuu.com/avonova/docs/avonova_tj_nstekatalog"
              >
                <i className="fa fa-chevron-right"></i> {t('home.PUSH_DIGITAL_SERVICES')}
              </a>
            </Trans>
            <Trans i18nKey="home.SYSTEM_INFORMATION" ns="translation">
              <a
                className="pill-primary link"
                target="_blank"
                href="https://info.avonova.se/sv/portal/systemdokumentation"
              >
                <i className="fa fa-chevron-right"></i> {t('home.SYSTEM_INFORMATION')}
              </a>
            </Trans>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (appState: ApplicationState) => ({
    authenticationState: appState.authentication,
  }),
  { ...AuthenticationStore.actions }
)(Home);
